module.exports = __webpack_public_path__ + "img/safe-total-boxes-newest_large.f39c8f84.png";